<template>
  <b-card
    class="card-congratulation-medal"
  >
    <h4>Parabéns 🎉 Caio</h4>

    <b-card-text class="font-small-3 w-75">
      Todos os dispositivos estão funcionando!
    </b-card-text>
    <!-- <h3 class="mb-75 mt-2 pt-50">
      <b-link>100% </b-link>
    </h3> -->
    <b-button
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      @click="$router.push('/devices')"
    >
      Ver Dispositivos
    </b-button>
    <b-img
      :src="require('/src/assets/images/illustration/badge.svg')"
      class="congratulation-medal"
      alt="Parabéns"
    />
  </b-card>
</template>

<script>
import {
  BCard, BCardText, BLink, BButton, BImg,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { kFormatter } from '@core/utils/filter'

export default {
  components: {
    BCard,
    BCardText,
    BLink,
    BImg,
    BButton,
  },
  directives: {
    Ripple,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    kFormatter,
  },
}
</script>
